import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=e34a046e&"
import script from "./BaseTabs.vue?vue&type=script&lang=ts&"
export * from "./BaseTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=e34a046e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports